import React, { useEffect, useRef } from 'react'
import { Player } from '@lottiefiles/react-lottie-player'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { useInView } from 'react-intersection-observer'

function AnimatedAsset({ src, customThreshold }) {
  const animationRef = useRef(null)

  const { m: isMobile } = useBreakpoint()
  const [ref, inView] = useInView({
    threshold: isMobile ? 0 : customThreshold || 0.5,
  })

  useEffect(() => {
    if (inView) {
      animationRef.current.play()
    } else {
      animationRef.current.stop()
      animationRef.current.setSeeker(0)
    }
  }, [inView])

  return (
    <div ref={ref} className="services__animated-asset">
      <Player ref={animationRef} keepLastFrame src={src} />
    </div>
  )
}

AnimatedAsset.propTypes = {
  src: PropTypes.object.isRequired,
  customThreshold: PropTypes.number,
}

export default AnimatedAsset
